// Custom hook for Services
import { useSelector, useDispatch } from 'react-redux';
import {
    fetchCategories,
    createCategory,
    updateCategory,
    deleteCategory,
    toggleCategoryStatus,
    clearError,
    resetState,
    selectCategories,
    selectCategoriesLoading,
    selectCategoriesError,
} from '../store/slices/categoriesSlice';

export const useCategories = () => {
    const dispatch = useDispatch();
    const categories = useSelector(selectCategories);
    const loading = useSelector(selectCategoriesLoading);
    const error = useSelector(selectCategoriesError);

    return {
        // State
        categories,
        loading,
        error,
        // Actions
        fetchCategories: () => dispatch(fetchCategories()),
        createCategory: (payload) => dispatch(createCategory(payload)).unwrap(),
        updateCategory: (id, data) => dispatch(updateCategory({ id, data })).unwrap(),
        deleteCategory: (id) => dispatch(deleteCategory(id)).unwrap(),
        toggleCategoryStatus: (id, isActive) => dispatch(toggleCategoryStatus({ id, isActive })).unwrap(),
        clearError: () => dispatch(clearError()),
        resetState: () => dispatch(resetState()),
        // Selector helper
        getServiceById: (id) => categories.find((service) => service.id === id),
    };
};

// Usage example in a component:
/*
import { useServices } from '../hooks/useServices';
import { useEffect } from 'react';

function ServicesPage() {
    const { 
        services, 
        loading, 
        error, 
        fetchCategories, 
        createCategory, 
        updateCategory, 
        deleteCategory,
        toggleCategoryStatus 
    } = useServices();

    useEffect(() => {
        fetchCategories();
    }, []);

    const handleCreate = async (formData) => {
        await createCategory({
            name: formData.name,
            image: formData.image,
            isActive: formData.isActive,
        });
    };

    const handleUpdate = async (id, formData) => {
        await updateCategory(id, {
            name: formData.name,
            image: formData.image,
            isActive: formData.isActive,
        });
    };

    const handleToggle = async (id, isActive) => {
        await toggleCategoryStatus(id, isActive);
    };

    if (loading) return <div>Loading...</div>;
    if (error) return <div>Error: {error}</div>;

    return (
        <div>
            {services.map(service => (
                <div key={service.id}>
                    <h3>{service.name}</h3>
                    <img src={service.image} alt={service.name} />
                    <button onClick={() => handleToggle(service.id, !service.isActive)}>
                        {service.isActive ? 'Deactivate' : 'Activate'}
                    </button>
                </div>
            ))}
        </div>
    );
}
*/

